import React, { useEffect } from 'react';
import { FaGlobeAmericas, FaUserTie, FaBriefcase } from 'react-icons/fa';
import PracticeAreaLayout from './PracticeAreaLayout';

const BusinessLawPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Business Law | Janssen Law Professional Corporation';
  }, []);

  return (
    <PracticeAreaLayout
      title="Business Law"
      subtitle="Comprehensive corporate and commercial legal services for Canadian and international businesses."
      heroImage="https://janssen-law.s3.us-east-2.amazonaws.com/business-law.jpg"
      slug="business-law"
      overview={
        <>
          <p>
            At Janssen Law, we provide comprehensive business law services tailored to
            the needs of Canadian and international businesses. Whether you are starting
            a new venture, expanding operations, or navigating complex commercial
            transactions, our team offers practical, results-oriented legal counsel.
          </p>
          <p>
            With Charlotte Janssen's extensive background at Baker & McKenzie spanning
            three continents, we bring an international perspective to local business
            matters. Our approach is consistent with in-house counsel, providing a broad
            range of legal advice that covers corporate governance, commercial contracts,
            and strategic business transactions.
          </p>
          <p>
            We serve business owners, entrepreneurs, and corporations with a focus on
            practical solutions that support your business objectives.
          </p>
        </>
      }
      services={[
        'Business Incorporations & Formations',
        'Mergers & Acquisitions',
        'Shareholder Agreements & Disputes',
        'Commercial Contracts & Negotiations',
        'Corporate Governance & Compliance',
        'Partnership Agreements',
        'Business Purchase & Sale Transactions',
        'Franchise Law',
        'International Business Transactions',
        'Banking & Finance',
        'Securities Compliance',
        'Commercial Leasing',
      ]}
      whyUsTitle="Why Choose Janssen Law for Business Law?"
      whyUsDescription="Our deep expertise in corporate and commercial matters, combined with international experience, sets us apart."
      whyUsFeatures={[
        {
          icon: <FaGlobeAmericas />,
          title: 'International Experience',
          description:
            'Background at Baker & McKenzie across Toronto, S\u00e3o Paulo, and London provides unique insight into cross-border transactions.',
        },
        {
          icon: <FaUserTie />,
          title: 'Personal Oversight',
          description:
            'Charlotte Janssen personally oversees every business matter, ensuring senior-level attention throughout.',
        },
        {
          icon: <FaBriefcase />,
          title: 'Practical Solutions',
          description:
            'We focus on actionable, business-friendly advice that supports your commercial objectives and growth.',
        },
      ]}
    />
  );
};

export default BusinessLawPage;
